import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { format } from "date-fns";
import compress from "browser-image-compression";

export function cn(...inputs) {
    return twMerge(clsx(inputs))
}

export function formatDateTime(date) {
    return format(date, "dd-MM-yyyy hh:mm a");
}

export function formatDate(date) {
    return format(date, "dd-MM-yyyy");
}


export async function compressImage(imageFile) {
    const options = {
        maxSizeMB: 1,
        useWebWorker: true,
        fileType: 'image/jpeg',
    }
    const compressedImage = await compress(imageFile, options);
    return convertBlobToFile(compressedImage, imageFile.name);
}

export function convertBlobToFile(blob, name) {
    const file = new File([blob], name, { type: blob.type });
    return file;
}

export function getDayGreeting() {
    const time = new Date().getHours();
    if (time < 12) {
        return "Good Morning";
    } else if (time < 18) {
        return "Good Afternoon";
    } else {
        return "Good Evening";
    }
}


export function getQueryParamsString(params) {
    // Generate query string from object, removing null and empty values
    const queryParams = new URLSearchParams();

    for (const [key, value] of Object.entries(params)) {
        if (value != null && value !== '') { // Only add non-null and non-empty values
            queryParams.append(key, value);
        }
    }

    return queryParams.toString();
}